import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isViewer, setIsViewer] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check if user is already logged in on mount
  useEffect(() => {
    const storedAuth = sessionStorage.getItem('balum_authenticated');
    const storedViewer = sessionStorage.getItem('balum_viewer');
    if (storedAuth === 'true') {
      setIsAuthenticated(true);
      setIsViewer(false);
    } else if (storedViewer === 'true') {
      setIsAuthenticated(true);
      setIsViewer(true);
    }
    setIsLoading(false);
  }, []);

  const login = (username, password) => {
    if (username === 'andre' && password === 'balum') {
      setIsAuthenticated(true);
      setIsViewer(false);
      sessionStorage.setItem('balum_authenticated', 'true');
      sessionStorage.removeItem('balum_viewer');
      return true;
    }
    if (username === 'visitante' && password === 'visitante') {
      setIsAuthenticated(true);
      setIsViewer(true);
      sessionStorage.setItem('balum_viewer', 'true');
      sessionStorage.removeItem('balum_authenticated');
      return true;
    }
    return false;
  };

  const logout = () => {
    setIsAuthenticated(false);
    setIsViewer(false);
    sessionStorage.removeItem('balum_authenticated');
    sessionStorage.removeItem('balum_viewer');
  };

  const value = {
    isAuthenticated,
    isViewer,
    isLoading,
    login,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

